/**
 * Parallax Quotes — Reverse-parallax background quote marks
 * Scrolls quote marks upward as the user scrolls down.
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initParallaxQuotes() {
    var el = document.querySelector('[data-parallax-quotes]');
    if (!el || prefersReducedMotion()) return;

    var inner = el.querySelector('.parallax-quotes__inner');
    if (!inner) return;

    var speed = parseFloat(el.getAttribute('data-parallax-speed')) || -0.15;
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () {
          inner.style.transform = 'translateY(' + (window.scrollY * speed) + 'px) translateZ(0)';
          ticking = false;
        });
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallaxQuotes);
  } else {
    initParallaxQuotes();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initParallaxQuotes);
  }
})();
